import React from "react";
import { Layers3, Boxes, Puzzle, IndianRupee } from "lucide-react";

const ModuleSummary = ({ subscribedBaseModuleDetails = [], total = 0 }) => {
  const totalBaseModules = subscribedBaseModuleDetails.length;

  const totalModules = subscribedBaseModuleDetails.reduce(
    (count, base) => count + (base?.SUBSCRIBED_MODULE_DETAILS?.length || 0),
    0,
  );

  const totalSubModules = subscribedBaseModuleDetails.reduce((count, base) => {
    const childCount =
      base?.SUBSCRIBED_MODULE_DETAILS?.reduce(
        (subCount, child) =>
          subCount + (child?.SUBSCRIBED_SUBMODULE_DETAILS?.length || 0),
        0,
      ) || 0;

    return count + childCount;
  }, 0);

  const stats = [
    {
      label: "Base Modules",
      value: totalBaseModules,
      icon: Layers3,
    },
    {
      label: "Modules",
      value: totalModules,
      icon: Boxes,
    },
    {
      label: "Sub Modules",
      value: totalSubModules,
      icon: Puzzle,
    },
  ];

  return (
    <div
      className="
                sticky bottom-0 z-40
                border-t
                border-slate-200 dark:border-slate-700

                bg-white/90 dark:bg-slate-900/90
                backdrop-blur-xl

                px-5 py-2
                shadow-[0_-4px_20px_rgba(0,0,0,0.04)]
                dark:shadow-[0_-4px_20px_rgba(0,0,0,0.3)]
            "
    >
      <div
        className="
                    flex items-center justify-between
                    gap-5 flex-wrap
                "
      >
        {/* ================= STATS ================= */}
        <div className="flex items-center gap-4 flex-wrap">
          {stats.map((stat) => {
            const Icon = stat.icon;

            return (
              <div
                key={stat.label}
                className="
                                    flex items-center gap-3

                                    px-4 py-2.5
                                    rounded-2xl

                                    bg-slate-50 dark:bg-slate-800/70
                                    border border-slate-200 dark:border-slate-700
                                "
              >
                {/* ICON */}
                <div
                  className="
                                        w-10 h-10 rounded-xl
                                        flex items-center justify-center

                                        bg-teal-100 dark:bg-teal-500/15
                                        text-teal-600 dark:text-teal-300
                                    "
                >
                  <Icon className="w-4 h-4" />
                </div>

                {/* TEXT */}
                <div>
                  <p
                    className="
                                            text-[10px]
                                            uppercase tracking-wider
                                            font-semibold

                                            text-slate-500 dark:text-slate-400
                                        "
                  >
                    {stat.label}
                  </p>

                  <p
                    className="
                                            text-lg font-bold
                                            text-slate-800 dark:text-white
                                            leading-tight
                                        "
                  >
                    {stat.value}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* ================= TOTAL ================= */}
        <div
          className="
                        ml-auto

                        flex items-center gap-4

                        px-5 py-3
                        rounded-2xl

                        bg-gradient-to-r
                        from-teal-500
                        to-emerald-500

                        text-white
                        shadow-lg
                    "
        >
          {/* ICON */}
          {/* <div
                        className="
                            w-11 h-11 rounded-xl
                            bg-white/15
                            flex items-center justify-center
                        "
                    >
                        <IndianRupee className="w-5 h-5" />
                    </div> */}

          {/* PRICE */}
          <div>
            <p className="text-xs text-white/80 font-medium">Monthly Total</p>

            <p className="text-2xl font-bold leading-tight">
              ${Number(total).toFixed(2)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleSummary;
